export default __webpack_public_path__ + "static/media/audienceacuity_id.afd93346.csv";